module.exports = __webpack_public_path__ + "img/table.fb9167ab.svg";